// src/components/intake/IntakeParts.jsx
import React from "react";
import { Field, Textarea, cn } from "../ui";

// The question pages' parts, from DESIGN.md §Onboarding. They live here, not in
// ui/, because only the question bodies use them (the wizard and the Questions
// page render the same bodies).

// Option card: the whole card is the checkbox (a visually hidden native input
// that keeps keyboard and screen-reader semantics); the tick shows `mark`.
export function OptionCard({
  label,
  checked,
  onChange,
  disabled,
  srExtra,
  mark,
}) {
  return (
    <label className="tw-relative tw-m-0 tw-block tw-cursor-pointer">
      <input
        type="checkbox"
        className="tw-peer tw-sr-only"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span
        className={cn(
          "tw-flex tw-min-h-24 tw-flex-col tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-bg-surface tw-p-4 tw-pr-12",
          "tw-transition-colors tw-duration-fast hover:tw-border-border",
          "peer-checked:tw-border-text-accent peer-checked:tw-bg-surface-selected",
          "peer-focus-visible:tw-outline peer-focus-visible:tw-outline-2 peer-focus-visible:tw-outline-offset-2 peer-focus-visible:tw-outline-focus-ring",
          "peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-45",
        )}
      >
        <b className="tw-text-sm">{label}</b>
        {srExtra && <span className="tw-sr-only">{srExtra}</span>}
      </span>
      <span
        aria-hidden="true"
        className="tw-absolute tw-right-3 tw-top-3 tw-grid tw-h-5 tw-w-5 tw-place-items-center tw-rounded-pill tw-border tw-border-solid tw-border-border tw-text-xs tw-font-bold peer-checked:tw-border-transparent peer-checked:tw-bg-text-accent peer-checked:tw-text-on-accent"
      >
        {mark}
      </span>
    </label>
  );
}

// An option set with an accessible group name (spec § Accessibility).
export function OptionGrid({ labelledBy, children }) {
  return (
    <div
      role="group"
      aria-labelledby={labelledBy}
      className="tw-my-6 tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-2 lg:tw-grid-cols-3"
    >
      {children}
    </div>
  );
}

// A small label over an option set ("Click all that apply").
export function SetLabel({ id, children }) {
  return (
    <p id={id} className="tw-mb-0 tw-mt-6 tw-text-sm tw-font-semibold tw-text-text">
      {children}
    </p>
  );
}

// A labelled free-text answer. `max` is the server's limit (decision 13).
export function TextAnswer({ id, label, value, onChange, max, placeholder }) {
  return (
    <Field id={id} label={label} className="tw-mt-6">
      <Textarea
        value={value}
        maxLength={max}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </Field>
  );
}

// Text limits (decision 13).
export const OTHER_MAX = 1000;
export const ABOUT_YOU_MAX = 2000;
